export const Cap = [
  {
    store: '0105',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0106',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0110',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0111',
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: '0114',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0115',
    May: 211,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: '0116',
    May: 384,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 384,
    February: 384,
    March: 384,
    April: 384
  },
  {
    store: '0117',
    May: 288,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: '0118',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0119',
    May: 288,
    June: 192,
    July: 192,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: '0121',
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: '0122',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0123',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0126',
    May: 346,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: '0127',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0128',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0129',
    May: 250,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: '0130',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0131',
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: '0132',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0133',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0134',
    May: 480,
    June: 269,
    July: 269,
    August: 404,
    September: 404,
    October: 404,
    November: 480,
    'Black Friday': 480,
    December: 480,
    January: 480,
    February: 480,
    March: 480,
    April: 480
  },
  {
    store: '0136',
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: '0137',
    May: 307,
    June: 250,
    July: 250,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307,
    March: 307,
    April: 307
  },
  {
    store: '0138',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0139',
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: '0140',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0141',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0143',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0144',
    May: 288,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: '0145',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0146',
    May: 422,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 422,
    February: 422,
    March: 422,
    April: 422
  },
  {
    store: '0147',
    May: 403,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 403,
    February: 403,
    March: 403,
    April: 403
  },
  {
    store: '0148',
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: '0149',
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: '0151',
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: '0152',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0153',
    May: 365,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 288,
    February: 365,
    March: 365,
    April: 365
  },
  {
    store: '0154',
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: '0155',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0156',
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: '0157',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0159',
    May: 250,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0160',
    May: 230,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: '0161',
    May: 250,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: '0163',
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: '0164',
    May: 250,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: '0165',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0170',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0172',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0174',
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: '0175',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0178',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0179',
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: '0201',
    May: 230,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: '0202',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0203',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0204',
    May: 250,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: '0205',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0206',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0207',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0208',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0209',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0210',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0213',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0218',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0220',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0221',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0222',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0224',
    May: 230,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: '0226',
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: '0232',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0233',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0234',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0238',
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: '0243',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0244',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0245',
    May: 307,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 307,
    March: 307,
    April: 307
  },
  {
    store: '0247',
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: '0248',
    May: 250,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: '0249',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0251',
    May: 230,
    June: 212,
    July: 212,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: '0253',
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: '0254',
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: '0255',
    May: 307,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 307,
    March: 307,
    April: 307
  },
  {
    store: '0256',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0257',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0258',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0260',
    May: 326,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 250,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: '0261',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0262',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0263',
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: '0264',
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: '0265',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0266',
    May: 307,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: '0268',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0270',
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: '0272',
    May: 365,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 288,
    February: 365,
    March: 365,
    April: 365
  },
  {
    store: '0273',
    May: 326,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: '0274',
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: '0275',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0276',
    May: 250,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 250,
    April: 250
  },
  {
    store: '0277',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0278',
    May: 192,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0279',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0280',
    May: 269,
    June: 212,
    July: 212,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: '0281',
    May: 230,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: '0283',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0284',
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: '0285',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0287',
    May: 307,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 307,
    February: 307,
    March: 307,
    April: 307
  },
  {
    store: '0288',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0289',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0347',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0349',
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: '0352',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0356',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0357',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0358',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0359',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0360',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0362',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0363',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0364',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0365',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0366',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0367',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0368',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0370',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0371',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0373',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0374',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0375',
    May: 422,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 384,
    'Black Friday': 384,
    December: 384,
    January: 422,
    February: 422,
    March: 422,
    April: 422
  },
  {
    store: '0376',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0378',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0380',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0381',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0383',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0385',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0386',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0389',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0401',
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: '0402',
    May: 250,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: '0403',
    May: 230,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: '0404',
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: '0405',
    May: 614,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 499,
    February: 499,
    March: 499,
    April: 614
  },
  {
    store: '0406',
    May: 288,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 288,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: '0408',
    May: 211,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0410',
    May: 518,
    June: 519,
    July: 519,
    August: 519,
    September: 519,
    October: 519,
    November: 519,
    'Black Friday': 519,
    December: 519,
    January: 518,
    February: 518,
    March: 518,
    April: 518
  },
  {
    store: '0411',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0413',
    May: 422,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 422,
    March: 422,
    April: 422
  },
  {
    store: '0414',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0415',
    May: 576,
    June: 384,
    July: 384,
    August: 384,
    September: 384,
    October: 384,
    November: 500,
    'Black Friday': 500,
    December: 500,
    January: 576,
    February: 576,
    March: 576,
    April: 576
  },
  {
    store: '0416',
    May: 211,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0417',
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: '0419',
    May: 384,
    June: 384,
    July: 384,
    August: 384,
    September: 384,
    October: 384,
    November: 384,
    'Black Friday': 384,
    December: 384,
    January: 384,
    February: 384,
    March: 384,
    April: 384
  },
  {
    store: '0420',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0421',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0422',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0423',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0424',
    May: 480,
    June: 480,
    July: 480,
    August: 480,
    September: 480,
    October: 480,
    November: 480,
    'Black Friday': 480,
    December: 480,
    January: 480,
    February: 480,
    March: 480,
    April: 480
  },
  {
    store: '0428',
    May: 211,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: '0429',
    May: 250,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: '0430',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0431',
    May: 614,
    June: 173,
    July: 173,
    August: 308,
    September: 308,
    October: 308,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 614,
    February: 614,
    March: 614,
    April: 614
  },
  {
    store: '0432',
    May: 403,
    June: 404,
    July: 404,
    August: 404,
    September: 404,
    October: 404,
    November: 404,
    'Black Friday': 404,
    December: 404,
    January: 403,
    February: 403,
    March: 403,
    April: 403
  },
  {
    store: '0441',
    May: 806,
    June: 634,
    July: 634,
    August: 634,
    September: 634,
    October: 634,
    November: 711,
    'Black Friday': 711,
    December: 711,
    January: 710,
    February: 806,
    March: 806,
    April: 806
  },
  {
    store: '0442',
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: '0443',
    May: 230,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 230,
    April: 230
  },
  {
    store: '0445',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0446',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0447',
    May: 557,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 500,
    'Black Friday': 500,
    December: 500,
    January: 557,
    February: 557,
    March: 557,
    April: 557
  },
  {
    store: '0452',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0453',
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: '0455',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0456',
    May: 250,
    June: 192,
    July: 192,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: '0457',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0458',
    May: 230,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: '0459',
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: '0464',
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: '0467',
    May: 307,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 307,
    February: 307,
    March: 307,
    April: 307
  },
  {
    store: '0468',
    May: 403,
    June: 346,
    July: 346,
    August: 404,
    September: 404,
    October: 404,
    November: 404,
    'Black Friday': 404,
    December: 404,
    January: 403,
    February: 403,
    March: 403,
    April: 403
  },
  {
    store: '0469',
    May: 480,
    June: 442,
    July: 442,
    August: 442,
    September: 442,
    October: 442,
    November: 442,
    'Black Friday': 442,
    December: 442,
    January: 480,
    February: 480,
    March: 480,
    April: 480
  },
  {
    store: '0470',
    May: 365,
    June: 308,
    July: 308,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 365,
    March: 365,
    April: 365
  },
  {
    store: '0471',
    May: 326,
    June: 288,
    July: 288,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: '0472',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0473',
    May: 230,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: '0474',
    May: 365,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 365,
    February: 365,
    March: 365,
    April: 365
  },
  {
    store: '0475',
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: '0476',
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: '0477',
    May: 288,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: '0478',
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: '0480',
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: '0481',
    May: 307,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 307,
    February: 307,
    March: 307,
    April: 307
  },
  {
    store: '0482',
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: '0483',
    May: 499,
    June: 384,
    July: 384,
    August: 384,
    September: 384,
    October: 384,
    November: 461,
    'Black Friday': 461,
    December: 461,
    January: 499,
    February: 499,
    March: 499,
    April: 499
  },
  {
    store: '0485',
    May: 307,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 307
  },
  {
    store: '0486',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0488',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0489',
    May: 230,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: '0501',
    May: 211,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: '0503',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0504',
    May: 211,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0505',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0506',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0507',
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: '0508',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0509',
    May: 326,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: '0513',
    May: 211,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 211,
    April: 211
  },
  {
    store: '0514',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0516',
    May: 250,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: '0518',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0519',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0522',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0523',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0524',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0526',
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: '0527',
    May: 326,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: '0528',
    May: 326,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 326,
    April: 326
  },
  {
    store: '0529',
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: '0530',
    May: 230,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: '0531',
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: '0534',
    May: 307,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 307,
    February: 307,
    March: 307,
    April: 307
  },
  {
    store: '0537',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0539',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0540',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0541',
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: '0542',
    May: 250,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: '0550',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0551',
    May: 288,
    June: 288,
    July: 288,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: '0552',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0553',
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: '0554',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0555',
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: '0556',
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: '0561',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0562',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0563',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0564',
    May: 326,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 326
  },
  {
    store: '0565',
    May: 230,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: '0566',
    May: 230,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: '0568',
    May: 250,
    June: 212,
    July: 212,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: '0569',
    May: 250,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: '0571',
    May: 192,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0574',
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: '0576',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0577',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0578',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0580',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0581',
    May: 250,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0582',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0583',
    May: 288,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 250
  },
  {
    store: '0584',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0585',
    May: 192,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0586',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0587',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0588',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0589',
    May: 230,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0597',
    May: 250,
    June: 173,
    July: 173,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: '0598',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0601',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0603',
    May: 384,
    June: 384,
    July: 384,
    August: 384,
    September: 384,
    October: 384,
    November: 384,
    'Black Friday': 384,
    December: 384,
    January: 384,
    February: 384,
    March: 384,
    April: 384
  },
  {
    store: '0606',
    May: 230,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0607',
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: '0608',
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: '0609',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0610',
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: '0611',
    May: 211,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: '0612',
    May: 269,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: '0614',
    May: 230,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: '0615',
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: '0616',
    May: 269,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0618',
    May: 422,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 423,
    'Black Friday': 423,
    December: 423,
    January: 422,
    February: 422,
    March: 422,
    April: 422
  },
  {
    store: '0620',
    May: 442,
    June: 442,
    July: 442,
    August: 442,
    September: 442,
    October: 442,
    November: 442,
    'Black Friday': 442,
    December: 442,
    January: 442,
    February: 442,
    March: 442,
    April: 442
  },
  {
    store: '0625',
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: '0627',
    May: 250,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: '0628',
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: '0629',
    May: 595,
    June: 596,
    July: 596,
    August: 596,
    September: 596,
    October: 596,
    November: 596,
    'Black Friday': 596,
    December: 596,
    January: 595,
    February: 595,
    March: 595,
    April: 595
  },
  {
    store: '0630',
    May: 230,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: '0632',
    May: 326,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: '0633',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0634',
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: '0635',
    May: 288,
    June: 288,
    July: 288,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: '0636',
    May: 288,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 288,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: '0637',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0638',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0639',
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: '0640',
    May: 384,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: '0641',
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: '0642',
    May: 326,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: '0643',
    May: 346,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 250,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: '0644',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0645',
    May: 326,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: '0647',
    May: 211,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: '0648',
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: '0649',
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: '0650',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0651',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0652',
    May: 307,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 307,
    February: 307,
    March: 307,
    April: 307
  },
  {
    store: '0653',
    May: 230,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0654',
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: '0657',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0658',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0659',
    May: 326,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: '0660',
    May: 230,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: '0662',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0663',
    May: 288,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 288,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: '0664',
    May: 250,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0665',
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: '0667',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0668',
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: '0669',
    May: 422,
    June: 423,
    July: 423,
    August: 423,
    September: 423,
    October: 423,
    November: 423,
    'Black Friday': 423,
    December: 423,
    January: 422,
    February: 422,
    March: 422,
    April: 422
  },
  {
    store: '0671',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0673',
    May: 211,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0674',
    May: 365,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 365,
    February: 365,
    March: 365,
    April: 365
  },
  {
    store: '0679',
    May: 230,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0680',
    May: 326,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: '0683',
    May: 269,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0684',
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: '0687',
    May: 269,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: '0701',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0702',
    May: 288,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 211,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: '0703',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0704',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0707',
    May: 326,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: '0711',
    May: 173,
    June: 0,
    July: 0,
    August: 0,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0720',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0721',
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: '0722',
    May: 288,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 211,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: '0723',
    May: 250,
    June: 212,
    July: 212,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: '0724',
    May: 230,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 230,
    April: 230
  },
  {
    store: '0725',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0726',
    May: 480,
    June: 480,
    July: 480,
    August: 480,
    September: 480,
    October: 480,
    November: 480,
    'Black Friday': 480,
    December: 480,
    January: 480,
    February: 480,
    March: 480,
    April: 480
  },
  {
    store: '0727',
    May: 230,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: '0728',
    May: 250,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: '0729',
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: '0730',
    May: 326,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: '0731',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0732',
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: '0733',
    May: 403,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 403,
    February: 403,
    March: 403,
    April: 403
  },
  {
    store: '0734',
    May: 307,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 307,
    February: 307,
    March: 307,
    April: 307
  },
  {
    store: '0735',
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: '0736',
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: '0737',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0739',
    May: 211,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0740',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0742',
    May: 250,
    June: 192,
    July: 192,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: '0743',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0744',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0745',
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: '0747',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0748',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0770',
    May: 211,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: '0772',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0773',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0775',
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: '0776',
    May: 269,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: '0778',
    May: 269,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: '0779',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0801',
    May: 326,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 288,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: '0802',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0803',
    May: 326,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: '0804',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0805',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0806',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0808',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0809',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0810',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0812',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0813',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0816',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0817',
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: '0818',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0863',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0865',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0866',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0875',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0877',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0880',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0881',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0882',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0883',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0884',
    May: 250,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 211,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: '0887',
    May: 230,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: '0888',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0901',
    May: 326,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: '0902',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0903',
    May: 403,
    June: 404,
    July: 404,
    August: 404,
    September: 404,
    October: 404,
    November: 404,
    'Black Friday': 404,
    December: 404,
    January: 403,
    February: 403,
    March: 403,
    April: 403
  },
  {
    store: '0904',
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: '0906',
    May: 346,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 346,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: '0907',
    May: 211,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0908',
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: '0909',
    May: 326,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: '0910',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0912',
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: '0914',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0915',
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: '0916',
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: '0917',
    May: 230,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: '0918',
    May: 230,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0919',
    May: 307,
    June: 308,
    July: 308,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307,
    March: 307,
    April: 307
  },
  {
    store: '0920',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0921',
    May: 326,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: '0922',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0925',
    May: 422,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346,
    March: 422,
    April: 422
  },
  {
    store: '0926',
    May: 288,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 288,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: '0927',
    May: 365,
    June: 250,
    July: 250,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307,
    March: 307,
    April: 365
  },
  {
    store: '0928',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0929',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0930',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0931',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0932',
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: '0933',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0934',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0935',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0939',
    May: 538,
    June: 173,
    July: 173,
    August: 423,
    September: 423,
    October: 423,
    November: 538,
    'Black Friday': 538,
    December: 538,
    January: 538,
    February: 538,
    March: 538,
    April: 538
  },
  {
    store: '0940',
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: '0941',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0942',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0943',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0944',
    May: 230,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: '0946',
    May: 230,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: '0947',
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: '0949',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0950',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0951',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0953',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0954',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0957',
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: '0959',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0961',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0962',
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: '0963',
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: '0965',
    May: 326,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: '0969',
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: '0970',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0974',
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: '0975',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0976',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0977',
    May: 480,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 384,
    February: 480,
    March: 480,
    April: 480
  },
  {
    store: '0980',
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: '0981',
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: '0982',
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: '0983',
    May: 250,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: '0984',
    May: 288,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: '0989',
    May: 192,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 192,
    April: 192
  },
  {
    store: 1001,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1002,
    May: 576,
    June: 576,
    July: 576,
    August: 576,
    September: 576,
    October: 576,
    November: 576,
    'Black Friday': 576,
    December: 576,
    January: 576,
    February: 576,
    March: 576,
    April: 576
  },
  {
    store: 1003,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1005,
    May: 307,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 307,
    March: 307,
    April: 307
  },
  {
    store: 1006,
    May: 595,
    June: 192,
    July: 192,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 595,
    February: 595,
    March: 595,
    April: 595
  },
  {
    store: 1007,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1009,
    May: 365,
    June: 365,
    July: 365,
    August: 365,
    September: 365,
    October: 365,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 365,
    February: 365,
    March: 365,
    April: 365
  },
  {
    store: 1010,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1012,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1013,
    May: 230,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1014,
    May: 211,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1017,
    May: 230,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 1018,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 1019,
    May: 250,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 1020,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 1022,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1028,
    May: 422,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 422,
    February: 422,
    March: 422,
    April: 422
  },
  {
    store: 1030,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 1031,
    May: 250,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 1032,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 1034,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1037,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1039,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1040,
    May: 326,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 1041,
    May: 422,
    June: 384,
    July: 384,
    August: 384,
    September: 384,
    October: 384,
    November: 423,
    'Black Friday': 423,
    December: 423,
    January: 384,
    February: 384,
    March: 384,
    April: 384
  },
  {
    store: 1043,
    May: 250,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1044,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1048,
    May: 557,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 557,
    February: 557,
    March: 557,
    April: 557
  },
  {
    store: 1050,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1052,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1053,
    May: 250,
    June: 192,
    July: 192,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 1055,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 1059,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1060,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 1061,
    May: 192,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1062,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 1064,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 1068,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1069,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1070,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1072,
    May: 326,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 1073,
    May: 326,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 250,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 1074,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1076,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1077,
    May: 403,
    June: 231,
    July: 231,
    August: 365,
    September: 365,
    October: 365,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 403,
    February: 403,
    March: 403,
    April: 403
  },
  {
    store: 1080,
    May: 326,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 1083,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: 1084,
    May: 384,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 384,
    March: 384,
    April: 384
  },
  {
    store: 1085,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1086,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1087,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 1088,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1089,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1092,
    May: 326,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 1103,
    May: 211,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 1104,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1105,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1106,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 1108,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1109,
    May: 326,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 250,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 1110,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1112,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1114,
    May: 230,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 1115,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1116,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1117,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1118,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1119,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1120,
    May: 346,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 288,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: 1121,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1122,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1124,
    May: 211,
    June: 192,
    July: 192,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 1126,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1127,
    May: 230,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 1129,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1130,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1171,
    May: 326,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 269,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 1202,
    May: 250,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 1206,
    May: 211,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1207,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1208,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 1209,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1211,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1212,
    May: 230,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 1213,
    May: 288,
    June: 288,
    July: 288,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: 1214,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 1215,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1216,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1217,
    May: 211,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 1218,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1220,
    May: 365,
    June: 327,
    July: 327,
    August: 365,
    September: 365,
    October: 365,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 365,
    February: 365,
    March: 365,
    April: 365
  },
  {
    store: 1221,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1222,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1223,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1225,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 1227,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1228,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1229,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1230,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 1231,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1233,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1234,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1235,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1236,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1238,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1239,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1241,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1242,
    May: 250,
    June: 212,
    July: 212,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 1244,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1245,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 1246,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 1247,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1248,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1249,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1250,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1251,
    May: 288,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: 1252,
    May: 326,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 1254,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1255,
    May: 307,
    June: 288,
    July: 288,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288,
    March: 307,
    April: 307
  },
  {
    store: 1256,
    May: 326,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 1257,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1258,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 1259,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1261,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1262,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1263,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 1264,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 1265,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 1266,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1267,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 1268,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1269,
    May: 365,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 307,
    February: 365,
    March: 365,
    April: 365
  },
  {
    store: 1271,
    May: 307,
    June: 308,
    July: 308,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307,
    March: 307,
    April: 307
  },
  {
    store: 1272,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1273,
    May: 307,
    June: 308,
    July: 308,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307,
    March: 307,
    April: 307
  },
  {
    store: 1274,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1277,
    May: 499,
    June: 500,
    July: 500,
    August: 500,
    September: 500,
    October: 500,
    November: 500,
    'Black Friday': 500,
    December: 500,
    January: 499,
    February: 499,
    March: 499,
    April: 499
  },
  {
    store: 1278,
    May: 250,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 1281,
    May: 250,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 1282,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1284,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1285,
    May: 230,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 1286,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 1287,
    May: 307,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 307,
    March: 307,
    April: 307
  },
  {
    store: 1289,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1301,
    May: 211,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 1302,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1303,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1304,
    May: 346,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 269,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: 1324,
    May: 403,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 404,
    'Black Friday': 404,
    December: 404,
    January: 403,
    February: 403,
    March: 403,
    April: 403
  },
  {
    store: 1326,
    May: 211,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1348,
    May: 173,
    June: 0,
    July: 0,
    August: 0,
    September: 0,
    October: 0,
    November: 0,
    'Black Friday': 0,
    December: 0,
    January: 0,
    February: 0,
    March: 0,
    April: 0
  },
  {
    store: 1349,
    May: 403,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 403,
    March: 403,
    April: 403
  },
  {
    store: 1379,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1380,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1401,
    May: 230,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 1402,
    May: 288,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 211,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: 1403,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 1404,
    May: 307,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 307,
    April: 307
  },
  {
    store: 1405,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1406,
    May: 326,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 250,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 1407,
    May: 211,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1409,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 1410,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1411,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1412,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1501,
    May: 403,
    June: 404,
    July: 404,
    August: 404,
    September: 404,
    October: 404,
    November: 404,
    'Black Friday': 404,
    December: 404,
    January: 403,
    February: 403,
    March: 403,
    April: 403
  },
  {
    store: 1502,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 1503,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1504,
    May: 326,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 1505,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1506,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1507,
    May: 250,
    June: 212,
    July: 212,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 1508,
    May: 250,
    June: 192,
    July: 192,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 1509,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1510,
    May: 595,
    June: 596,
    July: 596,
    August: 596,
    September: 596,
    October: 596,
    November: 596,
    'Black Friday': 596,
    December: 596,
    January: 595,
    February: 595,
    March: 595,
    April: 595
  },
  {
    store: 1511,
    May: 211,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 211,
    April: 211
  },
  {
    store: 1512,
    May: 326,
    June: 250,
    July: 250,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 1513,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1514,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1515,
    May: 307,
    June: 192,
    July: 192,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 307,
    March: 307,
    April: 307
  },
  {
    store: 1516,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 1517,
    May: 346,
    June: 250,
    July: 250,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: 1518,
    May: 192,
    June: 173,
    July: 173,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1519,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1520,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1521,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1522,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1523,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 1524,
    May: 288,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: 1525,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1526,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 1528,
    May: 307,
    June: 212,
    July: 212,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 307,
    March: 307,
    April: 307
  },
  {
    store: 1529,
    May: 250,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 1531,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 1532,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1534,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1535,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1537,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1538,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 1540,
    May: 365,
    June: 327,
    July: 327,
    August: 365,
    September: 365,
    October: 365,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 365,
    February: 365,
    March: 365,
    April: 365
  },
  {
    store: 1541,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1542,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1544,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 1545,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1546,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1547,
    May: 499,
    June: 192,
    July: 192,
    August: 250,
    September: 250,
    October: 250,
    November: 461,
    'Black Friday': 461,
    December: 461,
    January: 499,
    February: 499,
    March: 499,
    April: 499
  },
  {
    store: 1548,
    May: 288,
    June: 212,
    July: 212,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288,
    March: 288,
    April: 307
  },
  {
    store: 1549,
    May: 250,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 1550,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1551,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1552,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 1601,
    May: 269,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 1602,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1603,
    May: 192,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1604,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1605,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1608,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1610,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1701,
    May: 614,
    June: 557,
    July: 557,
    August: 557,
    September: 557,
    October: 557,
    November: 557,
    'Black Friday': 557,
    December: 557,
    January: 557,
    February: 614,
    March: 614,
    April: 614
  },
  {
    store: 1702,
    May: 384,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: 1703,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 1704,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1705,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1706,
    May: 518,
    June: 519,
    July: 519,
    August: 519,
    September: 519,
    October: 519,
    November: 519,
    'Black Friday': 519,
    December: 519,
    January: 518,
    February: 518,
    March: 518,
    April: 518
  },
  {
    store: 1707,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 1710,
    May: 326,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 1747,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 1748,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1749,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1750,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1754,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1755,
    May: 250,
    June: 212,
    July: 212,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 1763,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 1764,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1769,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1770,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1771,
    May: 250,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 1772,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1773,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1774,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1775,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1777,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 1801,
    May: 288,
    June: 192,
    July: 192,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 288,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: 1802,
    May: 326,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 1803,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1804,
    May: 250,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 1805,
    May: 384,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 288,
    February: 384,
    March: 384,
    April: 384
  },
  {
    store: 1806,
    May: 230,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 1807,
    May: 326,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 1808,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1809,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1810,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1811,
    May: 173,
    June: 0,
    July: 0,
    August: 0,
    September: 0,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1832,
    May: 230,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 1840,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1842,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1843,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1844,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 1845,
    May: 326,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 1846,
    May: 250,
    June: 192,
    July: 192,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 1848,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 1851,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1853,
    May: 211,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 1854,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1855,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1856,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1857,
    May: 365,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 365,
    March: 365,
    April: 365
  },
  {
    store: 1858,
    May: 269,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 1859,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1861,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1863,
    May: 269,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 1866,
    May: 211,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1901,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 1902,
    May: 326,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 1903,
    May: 211,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1904,
    May: 384,
    June: 384,
    July: 384,
    August: 384,
    September: 384,
    October: 384,
    November: 384,
    'Black Friday': 384,
    December: 384,
    January: 384,
    February: 384,
    March: 384,
    April: 384
  },
  {
    store: 1905,
    May: 211,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 1906,
    May: 307,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 1907,
    May: 307,
    June: 231,
    July: 231,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307,
    March: 307,
    April: 307
  },
  {
    store: 1908,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1909,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1911,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1912,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1913,
    May: 499,
    June: 500,
    July: 500,
    August: 500,
    September: 500,
    October: 500,
    November: 500,
    'Black Friday': 500,
    December: 500,
    January: 499,
    February: 499,
    March: 499,
    April: 499
  },
  {
    store: 1914,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1915,
    May: 250,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 1916,
    May: 518,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 422,
    February: 422,
    March: 518,
    April: 518
  },
  {
    store: 1917,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 1918,
    May: 403,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: 1919,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1920,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 1921,
    May: 230,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1922,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1924,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1926,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 1927,
    May: 403,
    June: 404,
    July: 404,
    August: 404,
    September: 404,
    October: 404,
    November: 404,
    'Black Friday': 404,
    December: 404,
    January: 403,
    February: 403,
    March: 403,
    April: 403
  },
  {
    store: 1928,
    May: 422,
    June: 423,
    July: 423,
    August: 423,
    September: 423,
    October: 423,
    November: 423,
    'Black Friday': 423,
    December: 423,
    January: 422,
    February: 422,
    March: 422,
    April: 422
  },
  {
    store: 1932,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1934,
    May: 269,
    June: 212,
    July: 212,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 1935,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 1936,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1937,
    May: 384,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 384,
    February: 384,
    March: 384,
    April: 384
  },
  {
    store: 1938,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 1939,
    May: 288,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 288,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: 1940,
    May: 326,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 1941,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 1942,
    May: 288,
    June: 212,
    July: 212,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 288,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: 1943,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 1944,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1948,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1950,
    May: 307,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 1952,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 1955,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1956,
    May: 230,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1957,
    May: 230,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 1961,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1962,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 1964,
    May: 211,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1967,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1969,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 1973,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1974,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1975,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 1976,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1977,
    May: 192,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1978,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1979,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1980,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 1981,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 1982,
    May: 307,
    June: 308,
    July: 308,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307,
    March: 307,
    April: 307
  },
  {
    store: 1983,
    May: 269,
    June: 192,
    July: 192,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 1984,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1986,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 1987,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 1989,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 2001,
    May: 288,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 230,
    February: 230,
    March: 288,
    April: 288
  },
  {
    store: 2002,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 2003,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 2009,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: 2010,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 2011,
    May: 250,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 2012,
    May: 269,
    June: 231,
    July: 231,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 2014,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 2016,
    May: 269,
    June: 192,
    July: 192,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 2017,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 2018,
    May: 326,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 2019,
    May: 307,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 307,
    February: 307,
    March: 307,
    April: 307
  },
  {
    store: 2021,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2023,
    May: 192,
    June: 173,
    July: 173,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 2024,
    May: 250,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 250
  },
  {
    store: 2025,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 2026,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 2030,
    May: 269,
    June: 231,
    July: 231,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 2033,
    May: 230,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 2034,
    May: 326,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 2036,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 2037,
    May: 326,
    June: 250,
    July: 250,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 2101,
    May: 192,
    June: 173,
    July: 173,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 2103,
    May: 211,
    June: 192,
    July: 192,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 2104,
    May: 211,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 2107,
    May: 288,
    June: 212,
    July: 212,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: 2108,
    May: 365,
    June: 327,
    July: 327,
    August: 365,
    September: 365,
    October: 365,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 365,
    February: 365,
    March: 365,
    April: 365
  },
  {
    store: 2109,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2111,
    May: 326,
    June: 250,
    July: 250,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 2113,
    May: 230,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 2114,
    May: 307,
    June: 212,
    July: 212,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307,
    March: 307,
    April: 307
  },
  {
    store: 2115,
    May: 211,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 2201,
    May: 211,
    June: 192,
    July: 192,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 2202,
    May: 269,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 2203,
    May: 211,
    June: 192,
    July: 192,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 2204,
    May: 346,
    June: 327,
    July: 327,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: 2205,
    May: 230,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 2207,
    May: 288,
    June: 269,
    July: 269,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: 2209,
    May: 499,
    June: 404,
    July: 404,
    August: 461,
    September: 461,
    October: 461,
    November: 461,
    'Black Friday': 461,
    December: 461,
    January: 499,
    February: 499,
    March: 499,
    April: 499
  },
  {
    store: 2211,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 2213,
    May: 211,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 2214,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2216,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 2217,
    May: 326,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 2218,
    May: 211,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 2219,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2220,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 2221,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 2301,
    May: 326,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 2302,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2303,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 2304,
    May: 384,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 384,
    'Black Friday': 384,
    December: 384,
    January: 384,
    February: 384,
    March: 384,
    April: 384
  },
  {
    store: 2305,
    May: 307,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 269,
    February: 307,
    March: 307,
    April: 307
  },
  {
    store: 2306,
    May: 384,
    June: 384,
    July: 384,
    August: 384,
    September: 384,
    October: 384,
    November: 384,
    'Black Friday': 384,
    December: 384,
    January: 384,
    February: 384,
    March: 384,
    April: 384
  },
  {
    store: 2307,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 2313,
    May: 326,
    June: 192,
    July: 192,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 2314,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2315,
    May: 595,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 461,
    February: 595,
    March: 595,
    April: 595
  },
  {
    store: 2316,
    May: 269,
    June: 212,
    July: 212,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 2317,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2318,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2323,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 2324,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 2389,
    May: 326,
    June: 231,
    July: 231,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 2401,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2403,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2404,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2405,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2406,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 2407,
    May: 269,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 2408,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2409,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2410,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2412,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2414,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2501,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2502,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2503,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2504,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2505,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 2506,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 2507,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2509,
    May: 269,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 2510,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2511,
    May: 288,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 211,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: 2550,
    May: 384,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 384
  },
  {
    store: 2551,
    May: 211,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 2552,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2554,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2555,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2557,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 2558,
    May: 461,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 461,
    February: 461,
    March: 461,
    April: 461
  },
  {
    store: 2559,
    May: 384,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 269,
    February: 384,
    March: 384,
    April: 384
  },
  {
    store: 2560,
    May: 365,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 288,
    February: 365,
    March: 365,
    April: 365
  },
  {
    store: 2561,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2562,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2563,
    May: 211,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 2564,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2565,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 2566,
    May: 365,
    June: 327,
    July: 327,
    August: 365,
    September: 365,
    October: 365,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 365,
    February: 365,
    March: 365,
    April: 365
  },
  {
    store: 2567,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2571,
    May: 269,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 230,
    March: 269,
    April: 269
  },
  {
    store: 2575,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 2576,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2577,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2578,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 2579,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 2580,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2581,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2582,
    May: 250,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 2583,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2584,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2587,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2589,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2602,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 2603,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2605,
    May: 614,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 614,
    February: 614,
    March: 614,
    April: 614
  },
  {
    store: 2607,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 2608,
    May: 269,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 2609,
    May: 250,
    June: 192,
    July: 192,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 2610,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 2611,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2612,
    May: 211,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2613,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2614,
    May: 326,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 2615,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 2619,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 2623,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2624,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 2650,
    May: 230,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 2651,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 2653,
    May: 230,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 2659,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2662,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 2663,
    May: 211,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 2665,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 2667,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2668,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: 2669,
    May: 307,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 307,
    February: 307,
    March: 307,
    April: 307
  },
  {
    store: 2670,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 2671,
    May: 211,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 2672,
    May: 365,
    June: 327,
    July: 327,
    August: 365,
    September: 365,
    October: 365,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 365,
    February: 365,
    March: 365,
    April: 365
  },
  {
    store: 2673,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 2674,
    May: 346,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: 2676,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 2677,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2678,
    May: 230,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 230,
    April: 230
  },
  {
    store: 2679,
    May: 326,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 250,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 2680,
    May: 230,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2681,
    May: 346,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: 2682,
    May: 230,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 2683,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 2684,
    May: 346,
    June: 269,
    July: 269,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: 2685,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2686,
    May: 269,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 230,
    March: 269,
    April: 269
  },
  {
    store: 2688,
    May: 269,
    June: 173,
    July: 173,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 2701,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2702,
    May: 250,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 2703,
    May: 288,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 288,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: 2704,
    May: 326,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 2706,
    May: 326,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 2707,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2708,
    May: 269,
    June: 173,
    July: 173,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 2709,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2710,
    May: 250,
    June: 212,
    July: 212,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 2711,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2714,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2715,
    May: 269,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 2716,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 2717,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 2718,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2720,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 2721,
    May: 422,
    June: 384,
    July: 384,
    August: 384,
    September: 384,
    October: 384,
    November: 384,
    'Black Friday': 384,
    December: 384,
    January: 384,
    February: 422,
    March: 422,
    April: 422
  },
  {
    store: 2722,
    May: 307,
    June: 231,
    July: 231,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307,
    March: 307,
    April: 307
  },
  {
    store: 2723,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 2724,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 2725,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2726,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2727,
    May: 326,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 2728,
    May: 288,
    June: 288,
    July: 288,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: 2729,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2731,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2732,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2733,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2734,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2736,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 2737,
    May: 211,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 211,
    April: 211
  },
  {
    store: 2738,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2739,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 2740,
    May: 230,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 2741,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 2742,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 2743,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 2744,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 2747,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2748,
    May: 403,
    June: 288,
    July: 288,
    August: 365,
    September: 365,
    October: 365,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 403,
    February: 403,
    March: 403,
    April: 403
  },
  {
    store: 2751,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 2752,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2754,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2755,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2757,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2758,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 2759,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2760,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2761,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 2762,
    May: 288,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 288,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: 2763,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 2764,
    May: 211,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 2765,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 2766,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2767,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2768,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2769,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2770,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 2771,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2772,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 2773,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2775,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2776,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 2779,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 2780,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 2781,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2782,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2785,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2789,
    May: 211,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 2801,
    May: 211,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 2802,
    May: 211,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 2803,
    May: 422,
    June: 192,
    July: 192,
    August: 346,
    September: 346,
    October: 346,
    November: 423,
    'Black Friday': 423,
    December: 423,
    January: 422,
    February: 422,
    March: 422,
    April: 422
  },
  {
    store: 2804,
    May: 307,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 307,
    March: 307,
    April: 307
  },
  {
    store: 2805,
    May: 230,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 2806,
    May: 365,
    June: 212,
    July: 212,
    August: 365,
    September: 365,
    October: 365,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 365,
    February: 365,
    March: 365,
    April: 365
  },
  {
    store: 2807,
    May: 269,
    June: 192,
    July: 192,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 2808,
    May: 422,
    June: 269,
    July: 269,
    August: 423,
    September: 423,
    October: 423,
    November: 423,
    'Black Friday': 423,
    December: 423,
    January: 422,
    February: 422,
    March: 422,
    April: 422
  },
  {
    store: 2809,
    May: 211,
    June: 192,
    July: 192,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 2810,
    May: 403,
    June: 250,
    July: 250,
    August: 384,
    September: 384,
    October: 384,
    November: 384,
    'Black Friday': 384,
    December: 384,
    January: 384,
    February: 384,
    March: 403,
    April: 403
  },
  {
    store: 2811,
    May: 365,
    June: 327,
    July: 327,
    August: 365,
    September: 365,
    October: 365,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 365,
    February: 365,
    March: 365,
    April: 365
  },
  {
    store: 2812,
    May: 346,
    June: 327,
    July: 327,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: 2813,
    May: 269,
    June: 173,
    July: 173,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 2817,
    May: 288,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: 2818,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 2820,
    May: 230,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 2821,
    May: 269,
    June: 231,
    July: 231,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 2825,
    May: 269,
    June: 250,
    July: 250,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 2826,
    May: 461,
    June: 192,
    July: 192,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 442,
    February: 461,
    March: 461,
    April: 461
  },
  {
    store: 2828,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 2829,
    May: 307,
    June: 212,
    July: 212,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307,
    March: 307,
    April: 307
  },
  {
    store: 2830,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2831,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 2832,
    May: 192,
    June: 173,
    July: 173,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 2833,
    May: 691,
    June: 557,
    July: 557,
    August: 634,
    September: 634,
    October: 634,
    November: 634,
    'Black Friday': 634,
    December: 634,
    January: 691,
    February: 691,
    March: 691,
    April: 691
  },
  {
    store: 2834,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 2840,
    May: 269,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 2841,
    May: 307,
    June: 212,
    July: 212,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307,
    March: 307,
    April: 307
  },
  {
    store: 2842,
    May: 211,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 2843,
    May: 230,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 2844,
    May: 442,
    June: 423,
    July: 423,
    August: 442,
    September: 442,
    October: 442,
    November: 442,
    'Black Friday': 442,
    December: 442,
    January: 442,
    February: 442,
    March: 442,
    April: 442
  },
  {
    store: 2845,
    May: 326,
    June: 269,
    July: 269,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: 2847,
    May: 269,
    June: 192,
    July: 192,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 2901,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 2902,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2903,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2905,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2906,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2907,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2909,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2910,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2912,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2913,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2914,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2915,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 2917,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3001,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 3002,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3003,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3004,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 3006,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 3007,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3008,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 3009,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3010,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 3011,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3012,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 3013,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3014,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 3015,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 3016,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3018,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 3019,
    May: 288,
    June: 231,
    July: 231,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: 3021,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3022,
    May: 307,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 307,
    February: 307,
    March: 307,
    April: 307
  },
  {
    store: 3024,
    May: 230,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 3025,
    May: 269,
    June: 192,
    July: 192,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 3026,
    May: 384,
    June: 308,
    July: 308,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 384,
    February: 384,
    March: 384,
    April: 384
  },
  {
    store: 3027,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3029,
    May: 269,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 269,
    April: 269
  },
  {
    store: 3032,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3033,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3034,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3036,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3037,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3038,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 3042,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3101,
    May: 230,
    June: 192,
    July: 192,
    August: 212,
    September: 212,
    October: 212,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 3102,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3103,
    May: 230,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 3104,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3105,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3106,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3117,
    May: 250,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 3118,
    May: 250,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 3119,
    May: 230,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 3201,
    May: 288,
    June: 269,
    July: 269,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: 3202,
    May: 230,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 3203,
    May: 269,
    June: 192,
    July: 192,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 3204,
    May: 576,
    June: 346,
    July: 346,
    August: 500,
    September: 500,
    October: 500,
    November: 576,
    'Black Friday': 576,
    December: 576,
    January: 576,
    February: 576,
    March: 576,
    April: 576
  },
  {
    store: 3206,
    May: 250,
    June: 231,
    July: 231,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 3208,
    May: 230,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 3209,
    May: 250,
    June: 231,
    July: 231,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 3210,
    May: 250,
    June: 173,
    July: 173,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 3301,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 3302,
    May: 422,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 346,
    February: 422,
    March: 422,
    April: 422
  },
  {
    store: 3303,
    May: 230,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 3304,
    May: 288,
    June: 288,
    July: 288,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: 3305,
    May: 307,
    June: 250,
    July: 250,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307,
    March: 307,
    April: 307
  },
  {
    store: 3306,
    May: 346,
    June: 288,
    July: 288,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: 3307,
    May: 250,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 3308,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 3309,
    May: 346,
    June: 173,
    July: 173,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: 3310,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3311,
    May: 250,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 3312,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3313,
    May: 230,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 3314,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3315,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 3316,
    May: 250,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 3318,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3320,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3322,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3324,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 3331,
    May: 230,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 3401,
    May: 480,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 403,
    March: 480,
    April: 480
  },
  {
    store: 3402,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3403,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3404,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 3405,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3406,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 3407,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3408,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3409,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3480,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3481,
    May: 230,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 3482,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3484,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 3485,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 3486,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 3487,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 3488,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 3489,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3501,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 3502,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 3503,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3504,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 3505,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 3507,
    May: 288,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: 3508,
    May: 250,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 3510,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 3511,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3514,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3515,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3516,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3517,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3601,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 3602,
    May: 230,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 3603,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 3604,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 3605,
    May: 307,
    June: 308,
    July: 308,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307,
    March: 307,
    April: 307
  },
  {
    store: 3606,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 3607,
    May: 307,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307,
    March: 307,
    April: 307
  },
  {
    store: 3608,
    May: 269,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 3609,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3610,
    May: 365,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 365,
    February: 365,
    March: 365,
    April: 365
  },
  {
    store: 3615,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 3616,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3620,
    May: 230,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 3625,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3626,
    May: 442,
    June: 442,
    July: 442,
    August: 442,
    September: 442,
    October: 442,
    November: 442,
    'Black Friday': 442,
    December: 442,
    January: 442,
    February: 442,
    March: 442,
    April: 442
  },
  {
    store: 3627,
    May: 230,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 3628,
    May: 211,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 3629,
    May: 250,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 250,
    April: 250
  },
  {
    store: 3631,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 3632,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 3633,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 3634,
    May: 288,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 288,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: 3637,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3638,
    May: 384,
    June: 384,
    July: 384,
    August: 384,
    September: 384,
    October: 384,
    November: 384,
    'Black Friday': 384,
    December: 384,
    January: 384,
    February: 384,
    March: 384,
    April: 384
  },
  {
    store: 3639,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3640,
    May: 307,
    June: 308,
    July: 308,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307,
    March: 307,
    April: 307
  },
  {
    store: 3641,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3642,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3644,
    May: 538,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 423,
    'Black Friday': 423,
    December: 423,
    January: 538,
    February: 538,
    March: 538,
    April: 538
  },
  {
    store: 3645,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3646,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3647,
    May: 230,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 3648,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3650,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3651,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 3652,
    May: 710,
    June: 269,
    July: 269,
    August: 596,
    September: 596,
    October: 596,
    November: 711,
    'Black Friday': 711,
    December: 711,
    January: 710,
    February: 710,
    March: 710,
    April: 710
  },
  {
    store: 3655,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 3661,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3662,
    May: 269,
    June: 212,
    July: 212,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 3663,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 3701,
    May: 384,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346,
    March: 384,
    April: 384
  },
  {
    store: 3703,
    May: 250,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 250,
    April: 250
  },
  {
    store: 3801,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 3803,
    May: 269,
    June: 192,
    July: 192,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 3804,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3805,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3806,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 3807,
    May: 346,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 269,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: 3808,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3809,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 3810,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 3811,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 3812,
    May: 365,
    June: 365,
    July: 365,
    August: 365,
    September: 365,
    October: 365,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 365,
    February: 365,
    March: 365,
    April: 365
  },
  {
    store: 3813,
    May: 461,
    June: 384,
    July: 384,
    August: 461,
    September: 461,
    October: 461,
    November: 461,
    'Black Friday': 461,
    December: 461,
    January: 461,
    February: 461,
    March: 461,
    April: 461
  },
  {
    store: 3814,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 3815,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 3816,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 3817,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 3818,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3819,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 3820,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3821,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3822,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 3823,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 3824,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 3825,
    May: 307,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 3827,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3828,
    May: 269,
    June: 192,
    July: 192,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 3830,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3831,
    May: 499,
    June: 500,
    July: 500,
    August: 500,
    September: 500,
    October: 500,
    November: 500,
    'Black Friday': 500,
    December: 500,
    January: 499,
    February: 499,
    March: 499,
    April: 499
  },
  {
    store: 3832,
    May: 288,
    June: 288,
    July: 288,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: 3833,
    May: 211,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 3835,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 3836,
    May: 365,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 365,
    February: 365,
    March: 365,
    April: 365
  },
  {
    store: 3838,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3841,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3842,
    May: 307,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 307,
    February: 307,
    March: 307,
    April: 307
  },
  {
    store: 3843,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3844,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 3846,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 3847,
    May: 211,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3848,
    May: 250,
    June: 192,
    July: 192,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 3852,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3854,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 3855,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 3856,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3857,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 3858,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 3859,
    May: 269,
    June: 192,
    July: 192,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 3860,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3861,
    May: 326,
    June: 212,
    July: 212,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 3862,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 3863,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 3864,
    May: 192,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 173,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 3866,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3867,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3868,
    May: 230,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 3872,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 3875,
    May: 250,
    June: 192,
    July: 192,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 3877,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3882,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 3883,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3885,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 3886,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3887,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 3888,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 3889,
    May: 211,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 3901,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3902,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3903,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 3904,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 3906,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3907,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 3908,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3909,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3911,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3913,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 3914,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 3915,
    May: 230,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 3917,
    May: 230,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 3918,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 3919,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4001,
    May: '1,382',
    June: 1191,
    July: 1191,
    August: 1191,
    September: 1191,
    October: 1191,
    November: 1191,
    'Black Friday': 1191,
    December: 1191,
    January: 1382,
    February: 1382,
    March: 1382,
    April: 1382
  },
  {
    store: 4002,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 4003,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 4004,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4006,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 4007,
    May: 230,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 4008,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4009,
    May: 307,
    June: 231,
    July: 231,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307,
    March: 307,
    April: 307
  },
  {
    store: 4010,
    May: 518,
    June: 519,
    July: 519,
    August: 519,
    September: 519,
    October: 519,
    November: 519,
    'Black Friday': 519,
    December: 519,
    January: 518,
    February: 518,
    March: 518,
    April: 518
  },
  {
    store: 4013,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 4014,
    May: 346,
    June: 231,
    July: 231,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307,
    March: 307,
    April: 307
  },
  {
    store: 4015,
    May: 307,
    June: 308,
    July: 308,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307,
    March: 307,
    April: 307
  },
  {
    store: 4017,
    May: 538,
    June: 538,
    July: 538,
    August: 538,
    September: 538,
    October: 538,
    November: 538,
    'Black Friday': 538,
    December: 538,
    January: 538,
    February: 538,
    March: 538,
    April: 538
  },
  {
    store: 4018,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 4019,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 4020,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4023,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4025,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4026,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4028,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4029,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4030,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 4031,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4032,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4034,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 4040,
    May: 384,
    June: 308,
    July: 308,
    August: 308,
    September: 308,
    October: 308,
    November: 384,
    'Black Friday': 384,
    December: 384,
    January: 384,
    February: 384,
    March: 384,
    April: 384
  },
  {
    store: 4054,
    May: 250,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 4101,
    May: 250,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 4102,
    May: 288,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 288,
    April: 288
  },
  {
    store: 4103,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 4104,
    May: 288,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: 4105,
    May: 230,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 4106,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 4108,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 4109,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4110,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 4112,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4113,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4114,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 4115,
    May: 288,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 288,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: 4116,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4117,
    May: 250,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 4118,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 4119,
    May: 269,
    June: 192,
    July: 192,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 4120,
    May: 346,
    June: 308,
    July: 308,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 346,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: 4121,
    May: 230,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 4122,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 4123,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 4124,
    May: 230,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 4125,
    May: 326,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 4126,
    May: 326,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 4127,
    May: 230,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 4128,
    May: 288,
    June: 173,
    July: 173,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: 4129,
    May: 211,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 4130,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4131,
    May: 346,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 346,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: 4132,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 4134,
    May: 230,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 4135,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 4136,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 4137,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 4138,
    May: 461,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 461,
    March: 461,
    April: 461
  },
  {
    store: 4139,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 4140,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 4141,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 4142,
    May: 250,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 4143,
    May: 326,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 4145,
    May: 230,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 4148,
    May: 230,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 4149,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 4150,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4152,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 4156,
    May: 230,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 4158,
    May: 250,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 4159,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4160,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4162,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4163,
    May: 326,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 326,
    April: 326
  },
  {
    store: 4164,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4166,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4168,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 4169,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4171,
    May: 230,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 4172,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 4173,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 4176,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 4177,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4178,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4180,
    May: 250,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 4181,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 4185,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4186,
    May: 326,
    June: 231,
    July: 231,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 4187,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 4188,
    May: 269,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 4213,
    May: 211,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4233,
    May: 269,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 4279,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 4280,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4282,
    May: 288,
    June: 288,
    July: 288,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: 4283,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 4284,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4285,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4286,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4287,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 4301,
    May: 211,
    June: 192,
    July: 192,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 4401,
    May: 384,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 384,
    February: 384,
    March: 384,
    April: 384
  },
  {
    store: 4402,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: 4403,
    May: 269,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 4406,
    May: 653,
    June: 500,
    July: 500,
    August: 500,
    September: 500,
    October: 500,
    November: 538,
    'Black Friday': 538,
    December: 538,
    January: 653,
    February: 653,
    March: 653,
    April: 653
  },
  {
    store: 4407,
    May: 538,
    June: 500,
    July: 500,
    August: 500,
    September: 500,
    October: 500,
    November: 538,
    'Black Friday': 538,
    December: 538,
    January: 538,
    February: 538,
    March: 538,
    April: 538
  },
  {
    store: 4408,
    May: 557,
    June: 557,
    July: 557,
    August: 557,
    September: 557,
    October: 557,
    November: 557,
    'Black Friday': 557,
    December: 557,
    January: 557,
    February: 557,
    March: 557,
    April: 557
  },
  {
    store: 4409,
    May: 326,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 4410,
    May: 326,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 4411,
    May: 230,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 4412,
    May: 710,
    June: 557,
    July: 557,
    August: 557,
    September: 557,
    October: 557,
    November: 672,
    'Black Friday': 672,
    December: 672,
    January: 710,
    February: 710,
    March: 710,
    April: 710
  },
  {
    store: 4413,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 4414,
    May: 346,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 346
  },
  {
    store: 4415,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4416,
    May: 634,
    June: 634,
    July: 634,
    August: 634,
    September: 634,
    October: 634,
    November: 634,
    'Black Friday': 634,
    December: 634,
    January: 634,
    February: 634,
    March: 634,
    April: 634
  },
  {
    store: 4417,
    May: 672,
    June: 672,
    July: 672,
    August: 672,
    September: 672,
    October: 672,
    November: 672,
    'Black Friday': 672,
    December: 672,
    January: 672,
    February: 672,
    March: 672,
    April: 672
  },
  {
    store: 4418,
    May: 250,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 4419,
    May: 422,
    June: 308,
    July: 308,
    August: 423,
    September: 423,
    October: 423,
    November: 423,
    'Black Friday': 423,
    December: 423,
    January: 422,
    February: 422,
    March: 422,
    April: 422
  },
  {
    store: 4420,
    May: 480,
    June: 346,
    July: 346,
    August: 480,
    September: 480,
    October: 480,
    November: 480,
    'Black Friday': 480,
    December: 480,
    January: 480,
    February: 480,
    March: 480,
    April: 480
  },
  {
    store: 4421,
    May: 230,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 4422,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 4461,
    May: 730,
    June: 730,
    July: 730,
    August: 730,
    September: 730,
    October: 730,
    November: 768,
    'Black Friday': 768,
    December: 768,
    January: 730,
    February: 730,
    March: 730,
    April: 730
  },
  {
    store: 4462,
    May: 250,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 4501,
    May: 326,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 4502,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4551,
    May: 230,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 4601,
    May: 422,
    June: 423,
    July: 423,
    August: 423,
    September: 423,
    October: 423,
    November: 423,
    'Black Friday': 423,
    December: 423,
    January: 422,
    February: 422,
    March: 422,
    April: 422
  },
  {
    store: 4602,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 4603,
    May: 288,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 288,
    April: 288
  },
  {
    store: 4604,
    May: 768,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 557,
    'Black Friday': 557,
    December: 557,
    January: 614,
    February: 768,
    March: 768,
    April: 768
  },
  {
    store: 4605,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 4607,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 4608,
    May: 365,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 365,
    March: 365,
    April: 365
  },
  {
    store: 4609,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 4611,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 4612,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4613,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 4614,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 4615,
    May: 365,
    June: 365,
    July: 365,
    August: 365,
    September: 365,
    October: 365,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 365,
    February: 365,
    March: 365,
    April: 365
  },
  {
    store: 4616,
    May: 192,
    June: 173,
    July: 173,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 4617,
    May: 403,
    June: 404,
    July: 404,
    August: 404,
    September: 404,
    October: 404,
    November: 404,
    'Black Friday': 404,
    December: 404,
    January: 403,
    February: 403,
    March: 403,
    April: 403
  },
  {
    store: 4618,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4619,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 4620,
    May: 326,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 4621,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 4622,
    May: 230,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 4624,
    May: 250,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 4626,
    May: 269,
    June: 212,
    July: 212,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 4627,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 4628,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 4631,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 4632,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 4633,
    May: 230,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 230,
    April: 230
  },
  {
    store: 4634,
    May: 211,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 4635,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 4637,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 4638,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 4639,
    May: 307,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307,
    March: 307,
    April: 307
  },
  {
    store: 4640,
    May: 269,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 4641,
    May: 326,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 4643,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4645,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 4647,
    May: 288,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 4648,
    May: 211,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4650,
    May: 134,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4653,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4654,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4655,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 4656,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 4658,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4659,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4660,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4701,
    May: 250,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 4702,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 4703,
    May: 269,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 269,
    April: 269
  },
  {
    store: 4704,
    May: 595,
    June: 557,
    July: 557,
    August: 557,
    September: 557,
    October: 557,
    November: 557,
    'Black Friday': 557,
    December: 557,
    January: 557,
    February: 557,
    March: 557,
    April: 557
  },
  {
    store: 4705,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 4706,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 4707,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 4708,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4709,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 4711,
    May: 288,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 4712,
    May: 442,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 403,
    February: 403,
    March: 403,
    April: 403
  },
  {
    store: 4713,
    May: 307,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307,
    March: 307,
    April: 307
  },
  {
    store: 4714,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 4715,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 4716,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 4718,
    May: 538,
    June: 384,
    July: 384,
    August: 480,
    September: 480,
    October: 480,
    November: 480,
    'Black Friday': 480,
    December: 480,
    January: 518,
    February: 538,
    March: 538,
    April: 538
  },
  {
    store: 4719,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 4720,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 4722,
    May: 269,
    June: 192,
    July: 192,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 4723,
    May: 730,
    June: 730,
    July: 730,
    August: 730,
    September: 730,
    October: 730,
    November: 730,
    'Black Friday': 730,
    December: 730,
    January: 730,
    February: 730,
    March: 730,
    April: 730
  },
  {
    store: 4724,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4725,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 4726,
    May: 250,
    June: 173,
    July: 173,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 4727,
    May: 346,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 346,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: 4728,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 4732,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4734,
    May: 173,
    June: 0,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4735,
    May: 211,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 211,
    April: 211
  },
  {
    store: 4737,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 4738,
    May: 250,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 4739,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 4740,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 4741,
    May: 346,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 346,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: 4742,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 4743,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 4745,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 4746,
    May: 480,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 480,
    February: 480,
    March: 480,
    April: 480
  },
  {
    store: 4747,
    May: 230,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 4748,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4801,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4802,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 4803,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4805,
    May: 250,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 4878,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4902,
    May: 634,
    June: 634,
    July: 634,
    August: 634,
    September: 634,
    October: 634,
    November: 634,
    'Black Friday': 634,
    December: 634,
    January: 634,
    February: 634,
    March: 634,
    April: 634
  },
  {
    store: 4903,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 4905,
    May: 269,
    June: 192,
    July: 192,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 4906,
    May: 403,
    June: 404,
    July: 404,
    August: 404,
    September: 404,
    October: 404,
    November: 404,
    'Black Friday': 404,
    December: 404,
    January: 403,
    February: 403,
    March: 403,
    April: 403
  },
  {
    store: 4907,
    May: 384,
    June: 288,
    July: 288,
    August: 384,
    September: 384,
    October: 384,
    November: 384,
    'Black Friday': 384,
    December: 384,
    January: 384,
    February: 384,
    March: 384,
    April: 384
  },
  {
    store: 4909,
    May: 653,
    June: 576,
    July: 576,
    August: 653,
    September: 653,
    October: 653,
    November: 653,
    'Black Friday': 653,
    December: 653,
    January: 653,
    February: 653,
    March: 653,
    April: 653
  },
  {
    store: 4910,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 4911,
    May: 269,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 4912,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4915,
    May: 326,
    June: 231,
    July: 231,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 4916,
    May: 211,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 4918,
    May: 346,
    June: 327,
    July: 327,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: 4919,
    May: 307,
    June: 269,
    July: 269,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307,
    March: 307,
    April: 307
  },
  {
    store: 4920,
    May: 326,
    June: 288,
    July: 288,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 4921,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 4923,
    May: 403,
    June: 404,
    July: 404,
    August: 404,
    September: 404,
    October: 404,
    November: 404,
    'Black Friday': 404,
    December: 404,
    January: 403,
    February: 403,
    March: 403,
    April: 403
  },
  {
    store: 4924,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 4925,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 4926,
    May: 365,
    June: 308,
    July: 308,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307,
    March: 307,
    April: 365
  },
  {
    store: 4928,
    May: 288,
    June: 212,
    July: 212,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: 4929,
    May: 269,
    June: 192,
    July: 192,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 4930,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4931,
    May: 461,
    June: 288,
    July: 288,
    August: 461,
    September: 461,
    October: 461,
    November: 461,
    'Black Friday': 461,
    December: 461,
    January: 461,
    February: 461,
    March: 461,
    April: 461
  },
  {
    store: 4935,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 4940,
    May: 230,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 4941,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 4942,
    May: 230,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 6001,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6002,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6003,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6004,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6005,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6037,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6105,
    May: 403,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 6106,
    May: 634,
    June: 288,
    July: 288,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 518,
    February: 595,
    March: 595,
    April: 595
  },
  {
    store: 6107,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 6113,
    May: 211,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6120,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6140,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6150,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6152,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6153,
    May: 384,
    June: 327,
    July: 327,
    August: 384,
    September: 384,
    October: 384,
    November: 384,
    'Black Friday': 384,
    December: 384,
    January: 384,
    February: 384,
    March: 384,
    April: 384
  },
  {
    store: 6154,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6155,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6158,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6159,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6160,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6161,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6167,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6168,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6169,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6172,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6174,
    May: 230,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 230,
    April: 230
  },
  {
    store: 6175,
    May: 250,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6176,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6178,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6201,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6202,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6203,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6204,
    May: 307,
    June: 308,
    July: 308,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307,
    March: 307,
    April: 307
  },
  {
    store: 6206,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6207,
    May: 461,
    June: 442,
    July: 442,
    August: 461,
    September: 461,
    October: 461,
    November: 461,
    'Black Friday': 461,
    December: 461,
    January: 461,
    February: 461,
    March: 461,
    April: 461
  },
  {
    store: 6208,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6209,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6210,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6212,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6213,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6214,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6215,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6217,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6218,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6220,
    May: 230,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 6221,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6223,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6225,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6226,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6228,
    May: 230,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 6229,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6230,
    May: 269,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 6233,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6234,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6235,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6236,
    May: 326,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 250,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 6242,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 6301,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6302,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6303,
    May: 326,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 250,
    March: 326,
    April: 326
  },
  {
    store: 6304,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6305,
    May: 288,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 288,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: 6306,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6310,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6311,
    May: 326,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 6312,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6313,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 6314,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6315,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6316,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 6318,
    May: 173,
    June: 0,
    July: 0,
    August: 0,
    September: 0,
    October: 0,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6319,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6320,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6321,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6322,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6323,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6324,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6325,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6326,
    May: 384,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 384,
    April: 384
  },
  {
    store: 6327,
    May: 326,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 6328,
    May: 230,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 6329,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6330,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6331,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 6332,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6334,
    May: 326,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 6335,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6336,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 6339,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6340,
    May: 192,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6341,
    May: 230,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 6342,
    May: 269,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 6343,
    May: 230,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 6346,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6348,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6349,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6350,
    May: 250,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 250,
    April: 250
  },
  {
    store: 6351,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6353,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 6355,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6356,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 6357,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6361,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6363,
    May: 307,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 307,
    February: 307,
    March: 307,
    April: 307
  },
  {
    store: 6364,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6365,
    May: 365,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 365,
    February: 365,
    March: 365,
    April: 365
  },
  {
    store: 6367,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6368,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6369,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6371,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6372,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6373,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6374,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6375,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 6376,
    May: 250,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 6377,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6378,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6379,
    May: 288,
    June: 288,
    July: 288,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: 6380,
    May: 250,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 6381,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: 6401,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 6402,
    May: 384,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 307,
    February: 384,
    March: 384,
    April: 384
  },
  {
    store: 6403,
    May: 384,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 384,
    February: 384,
    March: 384,
    April: 384
  },
  {
    store: 6405,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: 6407,
    May: 326,
    June: 231,
    July: 231,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 6408,
    May: 230,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 6409,
    May: 365,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 326,
    February: 326,
    March: 365,
    April: 365
  },
  {
    store: 6411,
    May: 288,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 288,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: 6412,
    May: 365,
    June: 365,
    July: 365,
    August: 365,
    September: 365,
    October: 365,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 365,
    February: 365,
    March: 365,
    April: 365
  },
  {
    store: 6415,
    May: 653,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 653,
    February: 653,
    March: 653,
    April: 653
  },
  {
    store: 6501,
    May: 230,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 6502,
    May: 326,
    June: 288,
    July: 288,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 6504,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6505,
    May: 230,
    June: 173,
    July: 173,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 6506,
    May: 269,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 6507,
    May: 269,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 6509,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6510,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6512,
    May: 230,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 6513,
    May: 307,
    June: 308,
    July: 308,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307,
    March: 307,
    April: 307
  },
  {
    store: 6514,
    May: 346,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: 6515,
    May: 288,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 250,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: 6516,
    May: 403,
    June: 288,
    July: 288,
    August: 384,
    September: 384,
    October: 384,
    November: 384,
    'Black Friday': 384,
    December: 384,
    January: 384,
    February: 384,
    March: 403,
    April: 403
  },
  {
    store: 6517,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6520,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6521,
    May: 326,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 326,
    April: 326
  },
  {
    store: 6523,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: 6525,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6526,
    May: 422,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 326,
    March: 422,
    April: 422
  },
  {
    store: 6528,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6529,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6530,
    May: 211,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6531,
    May: 326,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 326,
    April: 326
  },
  {
    store: 6532,
    May: 307,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 269,
    March: 307,
    April: 307
  },
  {
    store: 6533,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6534,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6537,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 6538,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 6539,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6540,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6541,
    May: 230,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 230,
    April: 230
  },
  {
    store: 6542,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6543,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6544,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6545,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6546,
    May: 230,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 6547,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6548,
    May: 269,
    June: 212,
    July: 212,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 6549,
    May: 250,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 6550,
    May: 230,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 6551,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6552,
    May: 730,
    June: 192,
    July: 192,
    August: 615,
    September: 615,
    October: 615,
    November: 730,
    'Black Friday': 730,
    December: 730,
    January: 730,
    February: 730,
    March: 730,
    April: 730
  },
  {
    store: 6553,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6554,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 6555,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 6556,
    May: 250,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 6557,
    May: 595,
    June: 596,
    July: 596,
    August: 596,
    September: 596,
    October: 596,
    November: 634,
    'Black Friday': 634,
    December: 634,
    January: 595,
    February: 595,
    March: 595,
    April: 595
  },
  {
    store: 6558,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6559,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6560,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6561,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 6562,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6563,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6564,
    May: 288,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: 6566,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6567,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6568,
    May: 691,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 692,
    'Black Friday': 692,
    December: 692,
    January: 691,
    February: 691,
    March: 691,
    April: 691
  },
  {
    store: 6570,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6571,
    May: 250,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6572,
    May: 288,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: 6574,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6575,
    May: 211,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6576,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6577,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6578,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6579,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6580,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6581,
    May: 211,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6583,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6584,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6585,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: 6586,
    May: 365,
    June: 212,
    July: 212,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 365,
    February: 365,
    March: 365,
    April: 365
  },
  {
    store: 6587,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6588,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6589,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6601,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6603,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6604,
    May: 384,
    June: 327,
    July: 327,
    August: 384,
    September: 384,
    October: 384,
    November: 384,
    'Black Friday': 384,
    December: 384,
    January: 384,
    February: 384,
    March: 384,
    April: 384
  },
  {
    store: 6609,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6610,
    May: 557,
    June: 557,
    July: 557,
    August: 557,
    September: 557,
    October: 557,
    November: 557,
    'Black Friday': 557,
    December: 557,
    January: 557,
    February: 557,
    March: 557,
    April: 557
  },
  {
    store: 6611,
    May: 288,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 6612,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6613,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6614,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: 6615,
    May: 230,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 6616,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6617,
    May: 422,
    June: 423,
    July: 423,
    August: 423,
    September: 423,
    October: 423,
    November: 423,
    'Black Friday': 423,
    December: 423,
    January: 422,
    February: 422,
    March: 422,
    April: 422
  },
  {
    store: 6618,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6619,
    May: 307,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 307,
    February: 307,
    March: 307,
    April: 307
  },
  {
    store: 6620,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6621,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6623,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6627,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: 6628,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6629,
    May: 307,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 307,
    April: 307
  },
  {
    store: 6630,
    May: 288,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: 6632,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6634,
    May: 230,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 6635,
    May: 672,
    June: 672,
    July: 672,
    August: 672,
    September: 672,
    October: 672,
    November: 672,
    'Black Friday': 672,
    December: 672,
    January: 672,
    February: 672,
    March: 672,
    April: 672
  },
  {
    store: 6636,
    May: 576,
    June: 576,
    July: 576,
    August: 576,
    September: 576,
    October: 576,
    November: 576,
    'Black Friday': 576,
    December: 576,
    January: 576,
    February: 576,
    March: 576,
    April: 576
  },
  {
    store: 6637,
    May: 230,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 6638,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 6639,
    May: 250,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6640,
    May: 211,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6643,
    May: 269,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 230,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 6644,
    May: 499,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 346,
    February: 499,
    March: 499,
    April: 499
  },
  {
    store: 6645,
    May: 480,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 423,
    'Black Friday': 423,
    December: 423,
    January: 480,
    February: 480,
    March: 480,
    April: 480
  },
  {
    store: 6646,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 6647,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6649,
    May: 288,
    June: 231,
    July: 231,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: 6650,
    May: 326,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 6651,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 6652,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6654,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 6656,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6657,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6660,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6661,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6662,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6663,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6664,
    May: 250,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 6665,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6667,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6668,
    May: 346,
    June: 308,
    July: 308,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: 6669,
    May: 307,
    June: 231,
    July: 231,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307,
    March: 307,
    April: 307
  },
  {
    store: 6670,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6672,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6673,
    May: 499,
    June: 500,
    July: 500,
    August: 500,
    September: 500,
    October: 500,
    November: 500,
    'Black Friday': 500,
    December: 500,
    January: 499,
    February: 499,
    March: 499,
    April: 499
  },
  {
    store: 6674,
    May: 384,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: 6675,
    May: 326,
    June: 365,
    July: 365,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 6677,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6678,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 6679,
    May: 307,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 307,
    February: 307,
    March: 307,
    April: 307
  },
  {
    store: 6680,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6681,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6682,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 6683,
    May: 346,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 346,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: 6684,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: 6687,
    May: 403,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 365,
    February: 403,
    March: 403,
    April: 403
  },
  {
    store: 6688,
    May: 403,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 403,
    March: 403,
    April: 403
  },
  {
    store: 6689,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6701,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: 6804,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6806,
    May: 211,
    June: 192,
    July: 192,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6807,
    May: 326,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 6808,
    May: 326,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 6809,
    May: 442,
    June: 327,
    July: 327,
    August: 442,
    September: 442,
    October: 442,
    November: 442,
    'Black Friday': 442,
    December: 442,
    January: 442,
    February: 442,
    March: 442,
    April: 442
  },
  {
    store: 6814,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6816,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6817,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6818,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 6819,
    May: 230,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 6820,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6821,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6822,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6827,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6828,
    May: 230,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 6830,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6831,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6832,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6833,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6834,
    May: 250,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 211,
    February: 211,
    March: 250,
    April: 250
  },
  {
    store: 6835,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6837,
    May: 173,
    June: 0,
    July: 0,
    August: 0,
    September: 0,
    October: 0,
    November: 0,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6838,
    May: 192,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6839,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6840,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6841,
    May: 211,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6842,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6843,
    May: 269,
    June: 212,
    July: 212,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 6844,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6845,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6846,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6847,
    May: 442,
    June: 173,
    July: 173,
    August: 250,
    September: 250,
    October: 250,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 442,
    February: 442,
    March: 442,
    April: 442
  },
  {
    store: 6848,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6851,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6852,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6853,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6855,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6856,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6857,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6859,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6860,
    May: 403,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 403,
    February: 403,
    March: 403,
    April: 403
  },
  {
    store: 6861,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6862,
    May: 250,
    June: 212,
    July: 212,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 6863,
    May: 250,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 6864,
    May: 230,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 6865,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6866,
    May: 422,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 365,
    February: 422,
    March: 422,
    April: 422
  },
  {
    store: 6869,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: 6871,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6872,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6874,
    May: 230,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 6875,
    May: 326,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 6876,
    May: 326,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 6877,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6878,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6883,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6884,
    May: 250,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6887,
    May: 230,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 6888,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6889,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6890,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6891,
    May: 288,
    June: 250,
    July: 250,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: 6892,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6893,
    May: 787,
    June: 192,
    July: 192,
    August: 557,
    September: 557,
    October: 557,
    November: 634,
    'Black Friday': 634,
    December: 634,
    January: 787,
    February: 787,
    March: 787,
    April: 787
  },
  {
    store: 6903,
    May: 326,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 6905,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6911,
    May: 230,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6917,
    May: 326,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 6918,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6919,
    May: 346,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 269,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: 6920,
    May: 211,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6921,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6923,
    May: 269,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 6925,
    May: 288,
    June: 250,
    July: 250,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: 6928,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6930,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6931,
    May: 269,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 250,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 6932,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6934,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6935,
    May: 211,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6936,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6940,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6941,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6942,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6943,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6945,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6946,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6947,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6948,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6950,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6951,
    May: 307,
    June: 212,
    July: 212,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307,
    March: 307,
    April: 307
  },
  {
    store: 6952,
    May: 288,
    June: 288,
    July: 288,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: 6954,
    May: 307,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 307,
    February: 307,
    March: 307,
    April: 307
  },
  {
    store: 6955,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6956,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6957,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6959,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6960,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6961,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6963,
    May: 288,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: 6964,
    May: 518,
    June: 404,
    July: 404,
    August: 404,
    September: 404,
    October: 404,
    November: 404,
    'Black Friday': 404,
    December: 404,
    January: 403,
    February: 518,
    March: 518,
    April: 518
  },
  {
    store: 6965,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6966,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6967,
    May: 192,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6968,
    May: 365,
    June: 365,
    July: 365,
    August: 365,
    September: 365,
    October: 365,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 365,
    February: 365,
    March: 365,
    April: 365
  },
  {
    store: 6971,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6972,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6974,
    May: 346,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 269,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: 6975,
    May: 288,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 288,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: 6976,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6977,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6978,
    May: 634,
    June: 596,
    July: 596,
    August: 634,
    September: 634,
    October: 634,
    November: 634,
    'Black Friday': 634,
    December: 634,
    January: 634,
    February: 634,
    March: 634,
    April: 634
  },
  {
    store: 6979,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 6980,
    May: 192,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6981,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6984,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6985,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6986,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 6987,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 6988,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 6989,
    May: 211,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 8201,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 8408,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 8412,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 8413,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 8418,
    May: 230,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 8419,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 8426,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 8427,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 8429,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 8430,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 8431,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 8433,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 8437,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 8438,
    May: 230,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 8439,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 8440,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 8444,
    May: 288,
    June: 212,
    July: 212,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: 8445,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 8446,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 8447,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 8452,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 8453,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 8454,
    May: 250,
    June: 212,
    July: 212,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 8456,
    May: 403,
    June: 404,
    July: 404,
    August: 404,
    September: 404,
    October: 404,
    November: 404,
    'Black Friday': 404,
    December: 404,
    January: 403,
    February: 403,
    March: 403,
    April: 403
  },
  {
    store: 8460,
    May: 269,
    June: 192,
    July: 192,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 8463,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 8465,
    May: 403,
    June: 404,
    July: 404,
    August: 404,
    September: 404,
    October: 404,
    November: 442,
    'Black Friday': 442,
    December: 442,
    January: 403,
    February: 403,
    March: 403,
    April: 403
  },
  {
    store: 8466,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 8469,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 8472,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 8473,
    May: 211,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 8475,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 8488,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 8492,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 8493,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 8517,
    May: 230,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 8518,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 8519,
    May: 230,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 8520,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 8521,
    May: 230,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 8523,
    May: 288,
    June: 288,
    July: 288,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: 8524,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 8525,
    May: 634,
    June: 365,
    July: 365,
    August: 365,
    September: 365,
    October: 365,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 442,
    February: 634,
    March: 634,
    April: 634
  },
  {
    store: 8526,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 8527,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 8528,
    May: 230,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 8529,
    May: 230,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 230,
    March: 230,
    April: 230
  },
  {
    store: 8531,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 8537,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 8539,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 8540,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 8545,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 8548,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 8550,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 8551,
    May: 557,
    June: 500,
    July: 500,
    August: 557,
    September: 557,
    October: 557,
    November: 557,
    'Black Friday': 557,
    December: 557,
    January: 557,
    February: 557,
    March: 557,
    April: 557
  },
  {
    store: 8552,
    May: 211,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 211,
    April: 211
  },
  {
    store: 8557,
    May: 557,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 442,
    February: 518,
    March: 557,
    April: 557
  },
  {
    store: 8560,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 8561,
    May: 288,
    June: 173,
    July: 173,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288,
    February: 288,
    March: 288,
    April: 288
  },
  {
    store: 8562,
    May: 384,
    June: 212,
    July: 212,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 365,
    March: 384,
    April: 384
  },
  {
    store: 8563,
    May: 307,
    June: 212,
    July: 212,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 307,
    March: 307,
    April: 307
  },
  {
    store: 8566,
    May: 422,
    June: 423,
    July: 423,
    August: 423,
    September: 423,
    October: 423,
    November: 423,
    'Black Friday': 423,
    December: 423,
    January: 422,
    February: 422,
    March: 422,
    April: 422
  },
  {
    store: 8571,
    May: 269,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 8572,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 8577,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 8580,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 8582,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 8583,
    May: 557,
    June: 557,
    July: 557,
    August: 557,
    September: 557,
    October: 557,
    November: 557,
    'Black Friday': 557,
    December: 557,
    January: 557,
    February: 557,
    March: 557,
    April: 557
  },
  {
    store: 8584,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 8597,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 8598,
    May: 211,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 8622,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 8913,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 8916,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 8918,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 8919,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 8922,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 8923,
    May: 365,
    June: 365,
    July: 365,
    August: 365,
    September: 365,
    October: 365,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 365,
    February: 365,
    March: 365,
    April: 365
  },
  {
    store: 8924,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 8926,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 8929,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269,
    February: 269,
    March: 269,
    April: 269
  },
  {
    store: 8931,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 8938,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 8939,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 8940,
    May: 384,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 384,
    February: 384,
    March: 384,
    April: 384
  },
  {
    store: 8941,
    May: 326,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 326,
    February: 326,
    March: 326,
    April: 326
  },
  {
    store: 8944,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 8949,
    May: 307,
    June: 308,
    July: 308,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307,
    February: 307,
    March: 307,
    April: 307
  },
  {
    store: 8951,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 8954,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 8955,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 8958,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 8964,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 8966,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 8975,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 8976,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 8979,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 8981,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  },
  {
    store: 8984,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 8987,
    May: 346,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 346,
    February: 346,
    March: 346,
    April: 346
  },
  {
    store: 8988,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192,
    February: 192,
    March: 192,
    April: 192
  },
  {
    store: 8994,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 8995,
    May: 250,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 250,
    March: 250,
    April: 250
  },
  {
    store: 8996,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173,
    February: 173,
    March: 173,
    April: 173
  },
  {
    store: 8998,
    May: 211,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211,
    February: 211,
    March: 211,
    April: 211
  }
];